import * as yup from 'yup'

export class VehicleCheckInRoofPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInRoofPhotoFile?: File = undefined
}

export const vehicleCheckInRoofPhotoValidationSchema = yup.object({
  vehicleCheckInRoofPhotoFile: yup.mixed().notRequired()
})
